/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import {useEffect} from 'react'
import clsx from 'clsx'
import {useTypedSelector} from 'helpers/reducers'
import HallAction from 'store/hall/HallAction'
import {useAppDispatch} from 'helpers/store'
import {DEFAULT_HALL_ID} from 'helpers/config'
import {useLocation, useNavigate} from 'react-router-dom'
import {identifyPosthogUser, resetPosthogUser} from 'utils/posthogUtils'

const IntegrityCheck = () => {
    const session = useTypedSelector((state) => state.sessionState.session)
    const hall = useTypedSelector((state) => state.hallState.hall)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const location = useLocation()

    const isAuthRoute =
        location.pathname === '/' ||
        location.pathname.includes('forgotten-password')

    const fetchHallHandler = () => {
        if (!hall && session?.access_token) {
            dispatch(HallAction.fetchHall(DEFAULT_HALL_ID))
        }
    }

    useEffect(() => {
        fetchHallHandler()
    }, [hall, session])

    useEffect(() => {
        if (!session?.access_token && !isAuthRoute) {
            navigate('/', { replace: true })
        }
    }, [isAuthRoute, navigate, session])

    useEffect(() => {
        if (session?.user?.id) {
            identifyPosthogUser(session.user)
            return
        }

        if (!session?.access_token) {
            resetPosthogUser()
        }
    }, [session?.access_token, session?.user])

    return <div className={clsx('LoginCheck')}></div>
}

export default IntegrityCheck
